const itemColorLimit = () => {
    $(document).ready(() => {
        var colorList = $('.ColorList');
        var colors = $('.color-select-button');
        var lastColor;
        var check = true
        colors.each(function (index) {
            var disToParent = $(this).offset().top - $(this).parent().offset().top - $(this).parent().scrollTop();
            if (disToParent > 114 && check) {
                lastColor = index - 1;
                check = false;
            }
        })
        var loadMoreButton = $('<div class="LoadMoreColor"><span>نمایش بیشتر</a></div>')
        if (colorList.innerHeight() > 118) {
            colorList.addClass('close');
            colorList.append(loadMoreButton);
            colors.eq(lastColor).css('visibility','hidden');
        }
        $('.LoadMoreColor').click(() => {
            $('.ColorList').removeClass('close');
            loadMoreButton.hide();
            colors.eq(lastColor).css('visibility', 'visible');
        })  
    })    
}

export {
    itemColorLimit
}